/*
@font-face {
  font-family: 'Univers';
  src: url('../fonts/Univers-55-roman-latin-extended.woff') format('truetype');
}
*/

@font-face {
  font-family: 'Univers';
  font-weight: 900;
  font-style: normal;
  src: url('../fonts/UniversLTStd.woff2') format('truetype');
}

@font-face {
  font-family: 'Univers';
  font-weight: 100;
  font-style: normal;
  src: url('../fonts/UniversLTStd-ThinUltraCn.woff2') format('truetype');
}

@font-face {
  font-family: 'Univers';
  font-weight: 900;
  font-style: normal;
  src: url('../fonts/UniversLTStd-XBlack.woff2') format('truetype');
}

@font-face {
  font-family: 'Univers';
  font-weight: 300;
  font-style: normal;
  src: url('../fonts/UniversLTStd-Light.woff2') format('truetype');
}

@font-face {
  font-family: 'Univers';
  font-weight: normal;
  font-style: normal;
  src: url('../fonts/UniversLTStd.woff2') format('truetype');
}

@font-face {
  font-family: 'Univers';
  font-weight: bold;
  font-style: normal;
  src: url('../fonts/UniversLTStd-Bold.woff2') format('truetype');
}

html {
  width: 100%;
  height: 100%;
}

body {
  width: 100%;
  height: 100%;
  background-color: var(--color-background);
  font-family: 'Univers', medium;
  font-size: 0.9rem;
  color: var(--color-font);
  margin: 0;

  --padding-default: 0.9rem;

  --content-min-width: 54rem;

  --font-size-large: 1.5rem;
  --font-size-medium: 0.75rem;
  --font-size-small: 0.6rem;

  --color-background: #F5F5F5;
  --color-primary: #007F00;
  --color-font: #252530;
  --color-grey-dark: #505050;
  --color-grey-medium: #E9E9E9;
  --color-grey-light: #F9F9F9;
  --color-button-active: #484848;
  --color-button-hovered: #757575;
  --color-border: #EAEAEA;

}

.sl-theme-bp {
  --sl-input-focus-ring-color: rgba(0, 127, 0, 0.45);
  --sl-input-border-color-focus: var(--color-primary);

  --sl-color-primary-50: rgb(223, 252, 215);
  --sl-color-primary-100: rgb(149, 247, 125);
  --sl-color-primary-200: rgb(118, 216, 96);
  --sl-color-primary-300: rgb(86, 186, 68);
  --sl-color-primary-400: rgb(53, 156, 39);
  --sl-color-primary-500: rgb(0, 127, 0);
  --sl-color-primary-600: rgb(0, 100, 0);
  --sl-color-primary-700: rgb(0, 56, 0);
  --sl-color-primary-800: rgb(0, 56, 0);
  --sl-color-primary-900: rgb(0, 56, 0);
  --sl-color-primary-950: rgb(0, 56, 0);
  --sl-color-primary-text: var(--color-font);

}
